var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline m-0" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("today")]),
                  _vm._v("\n        Reporte de marcado\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.save.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "py-0 px-2" },
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "p-0",
                          staticStyle: { "min-width": "100%" },
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      outline: "",
                                      type: "date",
                                      label: "Fecha inicio",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_inicio,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_inicio", $$v)
                                      },
                                      expression: "form.fecha_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      outline: "",
                                      type: "date",
                                      label: "Fecha fin",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_fin,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_fin", $$v)
                                      },
                                      expression: "form.fecha_fin"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      outline: "",
                                      items: _vm.unidades_especificas,
                                      "item-value": "id_unidad",
                                      "item-text": "nombre_unidad",
                                      label: "Unidad especifica",
                                      maxlength: "50"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_unidad_especifica,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_unidad_especifica",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_unidad_especifica"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: { outline: "", label: "Paterno" },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.paterno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "paterno", $$v)
                                      },
                                      expression: "form.paterno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: { outline: "", label: "Materno" },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.materno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "materno", $$v)
                                      },
                                      expression: "form.materno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: { outline: "", label: "Nombres" },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.nombres,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "nombres", $$v)
                                      },
                                      expression: "form.nombres"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      outline: "",
                                      label: "Cédula de identidad"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.ci,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "ci", $$v)
                                      },
                                      expression: "form.ci"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: { outline: "", label: "Item" },
                                    on: {
                                      input: function($event) {
                                        return _vm.filtraFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.item,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "item", $$v)
                                      },
                                      expression: "form.item"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: !_vm.bandera_boton_buscar,
                                color: "rgba(31,14,180,0.3)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.obtenerListaFuncionarios(
                                    _vm.form.fecha_inicio,
                                    _vm.form.fecha_fin
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("search")]),
                              _vm._v("\n              Buscar\n            ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "rgba(158,11,127,0.6)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.limpiarCampos()
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("redo")]),
                              _vm._v("\n              Limpiar\n            ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled:
                                  !_vm.bandera_boton_buscar ||
                                  (_vm.form.paterno != undefined &&
                                    _vm.form.paterno != "") ||
                                  (_vm.form.materno != undefined &&
                                    _vm.form.materno != "") ||
                                  (_vm.form.nombres != undefined &&
                                    _vm.form.nombres != "") ||
                                  (_vm.form.ci != undefined &&
                                    _vm.form.ci != "") ||
                                  (_vm.form.item != undefined &&
                                    _vm.form.item != ""),
                                color: "rgba(50,150,40,0.7)",
                                title: "Ver reporte ",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.verReporte(_vm.form, 1)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("picture_as_pdf")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled:
                                  !_vm.bandera_boton_buscar ||
                                  (_vm.form.paterno != undefined &&
                                    _vm.form.paterno != "") ||
                                  (_vm.form.materno != undefined &&
                                    _vm.form.materno != "") ||
                                  (_vm.form.nombres != undefined &&
                                    _vm.form.nombres != "") ||
                                  (_vm.form.ci != undefined &&
                                    _vm.form.ci != "") ||
                                  (_vm.form.item != undefined &&
                                    _vm.form.item != ""),
                                color: "rgba(50,150,40,0.7)",
                                title: "Ver reporte (XLS)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.verReporte(_vm.form, 3)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("description")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_filtrada_funcionarios,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros",
                  loading: _vm.loading,
                  "item-key": "index",
                  "rows-per-page-text": "Filas por pagina",
                  pagination: _vm.pagination,
                  "rows-per-page-items": [
                    5,
                    10,
                    20,
                    50,
                    { value: -1, text: "Todos" }
                  ]
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          _vm._l(props.headers, function(header) {
                            return _c(
                              "th",
                              {
                                key: header.text,
                                staticClass: "header-comprimido-tabla",
                                class: [
                                  "column sortable",
                                  _vm.pagination.descending ? "desc" : "asc",
                                  header.value === _vm.pagination.sortBy
                                    ? "active"
                                    : ""
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.changeSort(header.value)
                                  }
                                }
                              },
                              [
                                header.value
                                  ? _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("arrow_upward")
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(header.text) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c(
                          "td",
                          { staticClass: "text-xs-center py-0 px-1" },
                          [
                            _c(
                              "v-avatar",
                              {
                                attrs: {
                                  color: props.item.foto
                                    ? "#FFF"
                                    : "light-blue darken-4"
                                }
                              },
                              [
                                props.item.foto
                                  ? _c("img", {
                                      staticStyle: {
                                        border: "1px solid #7BAFD4 !important"
                                      },
                                      attrs: {
                                        src: _vm.url_backend + props.item.foto,
                                        alt: props.item.nombres[0]
                                      },
                                      on: {
                                        error: function($event) {
                                          return _vm.handleImageError(
                                            props.item
                                          )
                                        }
                                      }
                                    })
                                  : _c(
                                      "span",
                                      { staticClass: "white--text headline" },
                                      [
                                        _vm._v(
                                          _vm._s(props.item.nombres[0] || "-")
                                        )
                                      ]
                                    )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_item) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.ap_paterno) +
                              " " +
                              _vm._s(props.item.ap_materno) +
                              "\n            " +
                              _vm._s(props.item.nombres) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_doc) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.dependencia) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nombre_unidad) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center py-0 px-2" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#F58736",
                                  icon: "",
                                  title:
                                    "Ver reporte de asistencia del funcionario"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verReporte(props.item, 2)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("picture_as_pdf")])],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25757c0d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25757c0d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/Index.vue
// module id = null
// module chunks = 